import SocialNetworksWidget from './SocialNetworksWidget';

export default SocialNetworksWidget;
